import { GridSortModel } from "@mui/x-data-grid";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { PushNotificationControllerApi } from "../../services";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseContent,
} from "../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortModel;
  viewed?: boolean;
  patientId?: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author [Rajkumar Rathod]
 */
export const useGetAllNotifications = ({
  pagination,
  gridSorting,
  viewed,
  patientId,
  xTENANTID,
  enabled = true,
}: Props): useBaseContent<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;
  return useQuery({
    queryKey: [
      "get-all-notification",
      pagination,
      gridSorting,
      sortBy,
      viewed,
      patientId,
      sortDirect,
      xTENANTID,
    ],

    refetchOnWindowFocus: false,
    enabled: enabled,
    placeholderData: keepPreviousData,
    retry: (failureCount) => failureCount < 2,
    queryFn: async () =>
      await new PushNotificationControllerApi(getConfigObject())
        .getAllPushNotification(
          pageIndex,
          pagination.pageSize,
          sortBy,
          viewed,
          patientId,
          sortDirect,
          xTENANTID
        )
        .then((res) => res?.data),
  });
};
